import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import {
    Typography,
    PageBehaviourButton,
    AnimatedFadeContainer,
    IconPlus,
    IconMinus,
    AnchorAnimation,
} from '@ratehub/base-ui';


function ExpandableUnorderedList({ title, items }) {
    const [ isShowingMore, setIsShowingMore ] = useState(false);

    return (
        <Container className="rh-pb-2">
            <AnimatedFadeContainer
                className="fading-container"
                isVisible={isShowingMore}
            >
                <If condition={title}>
                    <h3 className="rh-title-3xs rh-mt-0">
                        {title}
                    </h3>
                </If>

                <ul className="unordered-list rh-text-s rh-mb-1_5">
                    <For
                        each="item"
                        of={items}
                        index="index"
                    >
                        <Choose>
                            {/* simple strings must use dangerouslySet; may include simple markup from CMS */}
                            <When condition={typeof item === 'string'}>
                                <li
                                    className="list-item rh-mb-0_5"
                                    key={index}
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            </When>
                            {/* objects, like from <FormattedMessage /> come through here */}
                            <Otherwise>
                                <li
                                    className="list-item rh-mb-0_5"
                                    key={index}
                                >
                                    {item}
                                </li>
                            </Otherwise>
                        </Choose>
                    </For>
                </ul>
            </AnimatedFadeContainer>

            <PageBehaviourButton
                data-name="show-more-info"
                size="small"
                iconLocation="left"
                iconComponent={isShowingMore ? IconMinus : IconPlus}
                message={(
                    <FormattedMessage
                        id="web-components.expandable-list.show-more"
                        defaultMessage="{isShowingMore, select, true {less details} other {more details}}"
                        values={{ isShowingMore: isShowingMore }}
                    />
                )}
                onClick={() => setIsShowingMore(!isShowingMore)}
            />
        </Container>
    );
}

ExpandableUnorderedList.propTypes = {
    title: PropTypes.node,
    items: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([ PropTypes.string, PropTypes.node ])),
        PropTypes.objectOf(PropTypes.oneOfType([ PropTypes.string, PropTypes.node ])), // mobx observable array
    ]).isRequired,
};

const Container = styled.div`
    max-width: 45em;

    > .fading-container {
        > .unordered-list {
            > .list-item {
                a.anchor-animation {
                    ${AnchorAnimation};
                }

                b,
                strong {
                    font-weight: ${Typography.WEIGHTS.MEDIUM};
                }
            }
        }
    }
`;

export default ExpandableUnorderedList;
